import React from "react";
import { withRouter } from "react-router-dom";
import RequiredProfileForm from "../../forms/RequiredProfileForm";
import { connect } from "react-redux";

export class RequiredProfile extends React.Component {
  render() {
    return (
      <div
        id="page-container"
        className="row align-items-center justify-content-center"
      >
        <RequiredProfileForm
          initialValues={{
            ...this.props.initialValues,
            first_name: '',
            last_name: '',
          }}
        />
      </div>
    );
  }
}

export default withRouter(
  connect(({ profile }) => ({
    initialValues: profile.profile
  }))(RequiredProfile)
);



// WEBPACK FOOTER //
// ./src/components/pages/RequiredProfile/RequiredProfile.jsx